import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import { martyrsApi } from '../services/api';
import { formatDateToGregorian } from '../utils/dateFormatter';
import { parsePlace } from '../utils/place';

const TimelinePage = () => {
  const [params] = useSearchParams();
  const [martyrs, setMartyrs] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    martyrsApi.getAll({ limit: 50 }).then((data) => {
      const list = data.martyrs || [];
      setMartyrs(list);
      setSelected(list.find((item) => String(item.id) === params.get('id')) || list[0] || null);
    });
  }, [params]);

  const place = parsePlace(selected?.place_of_martyrdom);
  const events = selected ? [
    selected.education_level && { title: 'التعليم', text: [selected.education_level, selected.university_name, selected.faculty].filter(Boolean).join(' — ') },
    selected.occupation && { title: 'المسيرة المهنية', text: selected.occupation },
    selected.spouse && { title: 'الحياة الأسرية', text: selected.spouse },
    { title: 'الاستشهاد', text: `${formatDateToGregorian(selected.date_of_martyrdom)} — ${place.state || ''} ${place.area || ''}` }
  ].filter(Boolean) : [];

  return (
    <Layout>
      <Seo title="الخط الزمني" />
      <PageHero eyebrow="المسيرة" title="الخط الزمني" subtitle="محطات مستخرجة من السيرة الموثّقة، دون حذف أي بيان قائم." />
      <div className="container-responsive grid gap-10 py-12 lg:grid-cols-3">
        <aside className="space-y-2">
          {martyrs.map((item) => (
            <button key={item.id} type="button" onClick={() => setSelected(item)} className={`w-full rounded-2xl px-4 py-3 text-right ${selected?.id === item.id ? 'bg-primary-900 text-white' : 'bg-white dark:bg-stone-900'}`}>
              {item.name_ar}
            </button>
          ))}
        </aside>
        <div className="lg:col-span-2">
          <ol className="relative border-r-2 border-gold-400 pr-8">
            {events.map((event, index) => (
              <li key={index} className="relative mb-10">
                <span className="absolute -right-[39px] top-1 h-4 w-4 rounded-full bg-gold-500" />
                <h3 className="text-xl font-bold">{event.title}</h3>
                <p className="text-stone-600 dark:text-stone-300">{event.text}</p>
              </li>
            ))}
          </ol>
          {selected && <Link to={`/martyr/${selected.id}`} className="btn btn-outline">سيرة {selected.name_ar}</Link>}
        </div>
      </div>
    </Layout>
  );
};

export default TimelinePage;
